/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResourceNotFoundRouteImport } from './routes/resource-not-found'
import { Route as R404RouteImport } from './routes/404'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as appAccessDeniedRouteImport } from './routes/(app)/access-denied'
import { Route as AuthauthRouteRouteImport } from './routes/auth/(auth)/route'
import { Route as appQcIndexRouteImport } from './routes/(app)/qc/index'
import { Route as AuthauthSuspendedCityRouteImport } from './routes/auth/(auth)/suspended-city'
import { Route as AuthauthInviteRouteImport } from './routes/auth/(auth)/invite'
import { Route as AuthauthCreateOrganizationRouteImport } from './routes/auth/(auth)/create-organization'
import { Route as AuthauthCreateCityClerkRouteImport } from './routes/auth/(auth)/create-city-clerk'
import { Route as AuthauthContinueRegistrationRouteImport } from './routes/auth/(auth)/continue-registration'
import { Route as AuthauthCompleteProfileRouteImport } from './routes/auth/(auth)/complete-profile'
import { Route as AuthauthCitySetupRouteImport } from './routes/auth/(auth)/city-setup'
import { Route as appSuperadminOverviewRouteImport } from './routes/(app)/superadmin/overview'
import { Route as appSuperadminBlockedAccountsRouteImport } from './routes/(app)/superadmin/blocked-accounts'
import { Route as appCityClerkSettingsRouteImport } from './routes/(app)/city-clerk/settings'
import { Route as appCityClerkProjectsRouteImport } from './routes/(app)/city-clerk/projects'
import { Route as appCityClerkMembersRouteImport } from './routes/(app)/city-clerk/members'
import { Route as appCityClerk_cityClerkRouteImport } from './routes/(app)/city-clerk/__city-clerk'
import { Route as appAdminImplicitAiImportRouteImport } from './routes/(app)/admin/implicit-ai-import'
import { Route as appOrganizationIdIndexRouteImport } from './routes/(app)/organization/$id/index'
import { Route as appCityClerkRolesAndPermissionsIndexRouteImport } from './routes/(app)/city-clerk/roles-and-permissions/index'
import { Route as appCityClerkIdIndexRouteImport } from './routes/(app)/city-clerk/$id/index'
import { Route as appCityClerkRolesAndPermissionsNewRouteImport } from './routes/(app)/city-clerk/roles-and-permissions/new'
import { Route as appCityClerkRolesAndPermissionsRoleIdRouteImport } from './routes/(app)/city-clerk/roles-and-permissions/$roleId'
import { Route as appCityClerkIdPermitsRouteImport } from './routes/(app)/city-clerk/$id/permits'
import { Route as appCityClerkIdOverallPermitsRouteImport } from './routes/(app)/city-clerk/$id/overall-permits'
import { Route as appCityClerkIdNotificationRouteImport } from './routes/(app)/city-clerk/$id/notification'
import { Route as appCityClerkIdDashboardRouteImport } from './routes/(app)/city-clerk/$id/dashboard'
import { Route as appCityClerkIdProjectsIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/index'
import { Route as appCityClerkIdPermitTemplateIndexRouteImport } from './routes/(app)/city-clerk/$id/permit-template/index'
import { Route as appCityClerkIdCompareIndexRouteImport } from './routes/(app)/city-clerk/$id/compare/index'
import { Route as appCityClerkIdPermitTemplateNewRouteImport } from './routes/(app)/city-clerk/$id/permit-template/new'
import { Route as appCityClerkIdPermitTemplateTemplateIdRouteImport } from './routes/(app)/city-clerk/$id/permit-template/$templateId'
import { Route as appCityClerkIdProjectsProjectIdRouteRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/route'
import { Route as appCityClerkIdProjectsProjectIdPermitsRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permits'
import { Route as appCityClerkIdProjectsProjectIdPermitResubmissionIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-resubmission/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/index'
import { Route as appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRouteImport } from './routes/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/index'

const appCityClerkRouteImport = createFileRoute('/(app)/city-clerk')()

const ResourceNotFoundRoute = ResourceNotFoundRouteImport.update({
  id: '/resource-not-found',
  path: '/resource-not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const appCityClerkRoute = appCityClerkRouteImport.update({
  id: '/city-clerk',
  path: '/city-clerk',
  getParentRoute: () => appRouteRoute,
} as any)
const appAccessDeniedRoute = appAccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => appRouteRoute,
} as any)
const AuthauthRouteRoute = AuthauthRouteRouteImport.update({
  id: '/auth/(auth)',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const appQcIndexRoute = appQcIndexRouteImport.update({
  id: '/qc/',
  path: '/qc/',
  getParentRoute: () => appRouteRoute,
} as any)
const AuthauthSuspendedCityRoute = AuthauthSuspendedCityRouteImport.update({
  id: '/suspended-city',
  path: '/suspended-city',
  getParentRoute: () => AuthauthRouteRoute,
} as any)
const AuthauthInviteRoute = AuthauthInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AuthauthRouteRoute,
} as any)
const AuthauthCreateOrganizationRoute =
  AuthauthCreateOrganizationRouteImport.update({
    id: '/create-organization',
    path: '/create-organization',
    getParentRoute: () => AuthauthRouteRoute,
  } as any)
const AuthauthCreateCityClerkRoute = AuthauthCreateCityClerkRouteImport.update({
  id: '/create-city-clerk',
  path: '/create-city-clerk',
  getParentRoute: () => AuthauthRouteRoute,
} as any)
const AuthauthContinueRegistrationRoute =
  AuthauthContinueRegistrationRouteImport.update({
    id: '/continue-registration',
    path: '/continue-registration',
    getParentRoute: () => AuthauthRouteRoute,
  } as any)
const AuthauthCompleteProfileRoute = AuthauthCompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => AuthauthRouteRoute,
} as any)
const AuthauthCitySetupRoute = AuthauthCitySetupRouteImport.update({
  id: '/city-setup',
  path: '/city-setup',
  getParentRoute: () => AuthauthRouteRoute,
} as any)
const appSuperadminOverviewRoute = appSuperadminOverviewRouteImport.update({
  id: '/superadmin/overview',
  path: '/superadmin/overview',
  getParentRoute: () => appRouteRoute,
} as any)
const appSuperadminBlockedAccountsRoute =
  appSuperadminBlockedAccountsRouteImport.update({
    id: '/superadmin/blocked-accounts',
    path: '/superadmin/blocked-accounts',
    getParentRoute: () => appRouteRoute,
  } as any)
const appCityClerkSettingsRoute = appCityClerkSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appCityClerkProjectsRoute = appCityClerkProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appCityClerkMembersRoute = appCityClerkMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appCityClerk_cityClerkRoute = appCityClerk_cityClerkRouteImport.update({
  id: '/__city-clerk',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appAdminImplicitAiImportRoute =
  appAdminImplicitAiImportRouteImport.update({
    id: '/admin/implicit-ai-import',
    path: '/admin/implicit-ai-import',
    getParentRoute: () => appRouteRoute,
  } as any)
const appOrganizationIdIndexRoute = appOrganizationIdIndexRouteImport.update({
  id: '/organization/$id/',
  path: '/organization/$id/',
  getParentRoute: () => appRouteRoute,
} as any)
const appCityClerkRolesAndPermissionsIndexRoute =
  appCityClerkRolesAndPermissionsIndexRouteImport.update({
    id: '/roles-and-permissions/',
    path: '/roles-and-permissions/',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdIndexRoute = appCityClerkIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appCityClerkRolesAndPermissionsNewRoute =
  appCityClerkRolesAndPermissionsNewRouteImport.update({
    id: '/roles-and-permissions/new',
    path: '/roles-and-permissions/new',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkRolesAndPermissionsRoleIdRoute =
  appCityClerkRolesAndPermissionsRoleIdRouteImport.update({
    id: '/roles-and-permissions/$roleId',
    path: '/roles-and-permissions/$roleId',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdPermitsRoute = appCityClerkIdPermitsRouteImport.update({
  id: '/$id/permits',
  path: '/$id/permits',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appCityClerkIdOverallPermitsRoute =
  appCityClerkIdOverallPermitsRouteImport.update({
    id: '/$id/overall-permits',
    path: '/$id/overall-permits',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdNotificationRoute =
  appCityClerkIdNotificationRouteImport.update({
    id: '/$id/notification',
    path: '/$id/notification',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdDashboardRoute = appCityClerkIdDashboardRouteImport.update({
  id: '/$id/dashboard',
  path: '/$id/dashboard',
  getParentRoute: () => appCityClerkRoute,
} as any)
const appCityClerkIdProjectsIndexRoute =
  appCityClerkIdProjectsIndexRouteImport.update({
    id: '/$id/projects/',
    path: '/$id/projects/',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdPermitTemplateIndexRoute =
  appCityClerkIdPermitTemplateIndexRouteImport.update({
    id: '/$id/permit-template/',
    path: '/$id/permit-template/',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdCompareIndexRoute =
  appCityClerkIdCompareIndexRouteImport.update({
    id: '/$id/compare/',
    path: '/$id/compare/',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdPermitTemplateNewRoute =
  appCityClerkIdPermitTemplateNewRouteImport.update({
    id: '/$id/permit-template/new',
    path: '/$id/permit-template/new',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdPermitTemplateTemplateIdRoute =
  appCityClerkIdPermitTemplateTemplateIdRouteImport.update({
    id: '/$id/permit-template/$templateId',
    path: '/$id/permit-template/$templateId',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdProjectsProjectIdRouteRoute =
  appCityClerkIdProjectsProjectIdRouteRouteImport.update({
    id: '/$id/projects/$projectId',
    path: '/$id/projects/$projectId',
    getParentRoute: () => appCityClerkRoute,
  } as any)
const appCityClerkIdProjectsProjectIdPermitsRoute =
  appCityClerkIdProjectsProjectIdPermitsRouteImport.update({
    id: '/permits',
    path: '/permits',
    getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
  } as any)
const appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute =
  appCityClerkIdProjectsProjectIdPermitResubmissionIndexRouteImport.update({
    id: '/permit-resubmission/',
    path: '/permit-resubmission/',
    getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
  } as any)
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/',
      path: '/permit-checklist-setup/$permitId/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )
const appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute =
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRouteImport.update(
    {
      id: '/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/',
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/',
      getParentRoute: () => appCityClerkIdProjectsProjectIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/resource-not-found': typeof ResourceNotFoundRoute
  '/auth': typeof AuthauthRouteRouteWithChildren
  '/access-denied': typeof appAccessDeniedRoute
  '/admin/implicit-ai-import': typeof appAdminImplicitAiImportRoute
  '/city-clerk': typeof appCityClerk_cityClerkRoute
  '/city-clerk/members': typeof appCityClerkMembersRoute
  '/city-clerk/projects': typeof appCityClerkProjectsRoute
  '/city-clerk/settings': typeof appCityClerkSettingsRoute
  '/superadmin/blocked-accounts': typeof appSuperadminBlockedAccountsRoute
  '/superadmin/overview': typeof appSuperadminOverviewRoute
  '/auth/city-setup': typeof AuthauthCitySetupRoute
  '/auth/complete-profile': typeof AuthauthCompleteProfileRoute
  '/auth/continue-registration': typeof AuthauthContinueRegistrationRoute
  '/auth/create-city-clerk': typeof AuthauthCreateCityClerkRoute
  '/auth/create-organization': typeof AuthauthCreateOrganizationRoute
  '/auth/invite': typeof AuthauthInviteRoute
  '/auth/suspended-city': typeof AuthauthSuspendedCityRoute
  '/qc': typeof appQcIndexRoute
  '/city-clerk/$id/dashboard': typeof appCityClerkIdDashboardRoute
  '/city-clerk/$id/notification': typeof appCityClerkIdNotificationRoute
  '/city-clerk/$id/overall-permits': typeof appCityClerkIdOverallPermitsRoute
  '/city-clerk/$id/permits': typeof appCityClerkIdPermitsRoute
  '/city-clerk/roles-and-permissions/$roleId': typeof appCityClerkRolesAndPermissionsRoleIdRoute
  '/city-clerk/roles-and-permissions/new': typeof appCityClerkRolesAndPermissionsNewRoute
  '/city-clerk/$id': typeof appCityClerkIdIndexRoute
  '/city-clerk/roles-and-permissions': typeof appCityClerkRolesAndPermissionsIndexRoute
  '/organization/$id': typeof appOrganizationIdIndexRoute
  '/city-clerk/$id/projects/$projectId': typeof appCityClerkIdProjectsProjectIdRouteRouteWithChildren
  '/city-clerk/$id/permit-template/$templateId': typeof appCityClerkIdPermitTemplateTemplateIdRoute
  '/city-clerk/$id/permit-template/new': typeof appCityClerkIdPermitTemplateNewRoute
  '/city-clerk/$id/compare': typeof appCityClerkIdCompareIndexRoute
  '/city-clerk/$id/permit-template': typeof appCityClerkIdPermitTemplateIndexRoute
  '/city-clerk/$id/projects': typeof appCityClerkIdProjectsIndexRoute
  '/city-clerk/$id/projects/$projectId/permits': typeof appCityClerkIdProjectsProjectIdPermitsRoute
  '/city-clerk/$id/projects/$projectId/permit-resubmission': typeof appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/resource-not-found': typeof ResourceNotFoundRoute
  '/auth': typeof AuthauthRouteRouteWithChildren
  '/access-denied': typeof appAccessDeniedRoute
  '/admin/implicit-ai-import': typeof appAdminImplicitAiImportRoute
  '/city-clerk': typeof appCityClerk_cityClerkRoute
  '/city-clerk/members': typeof appCityClerkMembersRoute
  '/city-clerk/projects': typeof appCityClerkProjectsRoute
  '/city-clerk/settings': typeof appCityClerkSettingsRoute
  '/superadmin/blocked-accounts': typeof appSuperadminBlockedAccountsRoute
  '/superadmin/overview': typeof appSuperadminOverviewRoute
  '/auth/city-setup': typeof AuthauthCitySetupRoute
  '/auth/complete-profile': typeof AuthauthCompleteProfileRoute
  '/auth/continue-registration': typeof AuthauthContinueRegistrationRoute
  '/auth/create-city-clerk': typeof AuthauthCreateCityClerkRoute
  '/auth/create-organization': typeof AuthauthCreateOrganizationRoute
  '/auth/invite': typeof AuthauthInviteRoute
  '/auth/suspended-city': typeof AuthauthSuspendedCityRoute
  '/qc': typeof appQcIndexRoute
  '/city-clerk/$id/dashboard': typeof appCityClerkIdDashboardRoute
  '/city-clerk/$id/notification': typeof appCityClerkIdNotificationRoute
  '/city-clerk/$id/overall-permits': typeof appCityClerkIdOverallPermitsRoute
  '/city-clerk/$id/permits': typeof appCityClerkIdPermitsRoute
  '/city-clerk/roles-and-permissions/$roleId': typeof appCityClerkRolesAndPermissionsRoleIdRoute
  '/city-clerk/roles-and-permissions/new': typeof appCityClerkRolesAndPermissionsNewRoute
  '/city-clerk/$id': typeof appCityClerkIdIndexRoute
  '/city-clerk/roles-and-permissions': typeof appCityClerkRolesAndPermissionsIndexRoute
  '/organization/$id': typeof appOrganizationIdIndexRoute
  '/city-clerk/$id/projects/$projectId': typeof appCityClerkIdProjectsProjectIdRouteRouteWithChildren
  '/city-clerk/$id/permit-template/$templateId': typeof appCityClerkIdPermitTemplateTemplateIdRoute
  '/city-clerk/$id/permit-template/new': typeof appCityClerkIdPermitTemplateNewRoute
  '/city-clerk/$id/compare': typeof appCityClerkIdCompareIndexRoute
  '/city-clerk/$id/permit-template': typeof appCityClerkIdPermitTemplateIndexRoute
  '/city-clerk/$id/projects': typeof appCityClerkIdProjectsIndexRoute
  '/city-clerk/$id/projects/$projectId/permits': typeof appCityClerkIdProjectsProjectIdPermitsRoute
  '/city-clerk/$id/projects/$projectId/permit-resubmission': typeof appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute
  '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/404': typeof R404Route
  '/resource-not-found': typeof ResourceNotFoundRoute
  '/auth/(auth)': typeof AuthauthRouteRouteWithChildren
  '/(app)/access-denied': typeof appAccessDeniedRoute
  '/(app)/admin/implicit-ai-import': typeof appAdminImplicitAiImportRoute
  '/(app)/city-clerk': typeof appCityClerkRouteWithChildren
  '/(app)/city-clerk/__city-clerk': typeof appCityClerk_cityClerkRoute
  '/(app)/city-clerk/members': typeof appCityClerkMembersRoute
  '/(app)/city-clerk/projects': typeof appCityClerkProjectsRoute
  '/(app)/city-clerk/settings': typeof appCityClerkSettingsRoute
  '/(app)/superadmin/blocked-accounts': typeof appSuperadminBlockedAccountsRoute
  '/(app)/superadmin/overview': typeof appSuperadminOverviewRoute
  '/auth/(auth)/city-setup': typeof AuthauthCitySetupRoute
  '/auth/(auth)/complete-profile': typeof AuthauthCompleteProfileRoute
  '/auth/(auth)/continue-registration': typeof AuthauthContinueRegistrationRoute
  '/auth/(auth)/create-city-clerk': typeof AuthauthCreateCityClerkRoute
  '/auth/(auth)/create-organization': typeof AuthauthCreateOrganizationRoute
  '/auth/(auth)/invite': typeof AuthauthInviteRoute
  '/auth/(auth)/suspended-city': typeof AuthauthSuspendedCityRoute
  '/(app)/qc/': typeof appQcIndexRoute
  '/(app)/city-clerk/$id/dashboard': typeof appCityClerkIdDashboardRoute
  '/(app)/city-clerk/$id/notification': typeof appCityClerkIdNotificationRoute
  '/(app)/city-clerk/$id/overall-permits': typeof appCityClerkIdOverallPermitsRoute
  '/(app)/city-clerk/$id/permits': typeof appCityClerkIdPermitsRoute
  '/(app)/city-clerk/roles-and-permissions/$roleId': typeof appCityClerkRolesAndPermissionsRoleIdRoute
  '/(app)/city-clerk/roles-and-permissions/new': typeof appCityClerkRolesAndPermissionsNewRoute
  '/(app)/city-clerk/$id/': typeof appCityClerkIdIndexRoute
  '/(app)/city-clerk/roles-and-permissions/': typeof appCityClerkRolesAndPermissionsIndexRoute
  '/(app)/organization/$id/': typeof appOrganizationIdIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId': typeof appCityClerkIdProjectsProjectIdRouteRouteWithChildren
  '/(app)/city-clerk/$id/permit-template/$templateId': typeof appCityClerkIdPermitTemplateTemplateIdRoute
  '/(app)/city-clerk/$id/permit-template/new': typeof appCityClerkIdPermitTemplateNewRoute
  '/(app)/city-clerk/$id/compare/': typeof appCityClerkIdCompareIndexRoute
  '/(app)/city-clerk/$id/permit-template/': typeof appCityClerkIdPermitTemplateIndexRoute
  '/(app)/city-clerk/$id/projects/': typeof appCityClerkIdProjectsIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permits': typeof appCityClerkIdProjectsProjectIdPermitsRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-resubmission/': typeof appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/': typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/resource-not-found'
    | '/auth'
    | '/access-denied'
    | '/admin/implicit-ai-import'
    | '/city-clerk'
    | '/city-clerk/members'
    | '/city-clerk/projects'
    | '/city-clerk/settings'
    | '/superadmin/blocked-accounts'
    | '/superadmin/overview'
    | '/auth/city-setup'
    | '/auth/complete-profile'
    | '/auth/continue-registration'
    | '/auth/create-city-clerk'
    | '/auth/create-organization'
    | '/auth/invite'
    | '/auth/suspended-city'
    | '/qc'
    | '/city-clerk/$id/dashboard'
    | '/city-clerk/$id/notification'
    | '/city-clerk/$id/overall-permits'
    | '/city-clerk/$id/permits'
    | '/city-clerk/roles-and-permissions/$roleId'
    | '/city-clerk/roles-and-permissions/new'
    | '/city-clerk/$id'
    | '/city-clerk/roles-and-permissions'
    | '/organization/$id'
    | '/city-clerk/$id/projects/$projectId'
    | '/city-clerk/$id/permit-template/$templateId'
    | '/city-clerk/$id/permit-template/new'
    | '/city-clerk/$id/compare'
    | '/city-clerk/$id/permit-template'
    | '/city-clerk/$id/projects'
    | '/city-clerk/$id/projects/$projectId/permits'
    | '/city-clerk/$id/projects/$projectId/permit-resubmission'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/resource-not-found'
    | '/auth'
    | '/access-denied'
    | '/admin/implicit-ai-import'
    | '/city-clerk'
    | '/city-clerk/members'
    | '/city-clerk/projects'
    | '/city-clerk/settings'
    | '/superadmin/blocked-accounts'
    | '/superadmin/overview'
    | '/auth/city-setup'
    | '/auth/complete-profile'
    | '/auth/continue-registration'
    | '/auth/create-city-clerk'
    | '/auth/create-organization'
    | '/auth/invite'
    | '/auth/suspended-city'
    | '/qc'
    | '/city-clerk/$id/dashboard'
    | '/city-clerk/$id/notification'
    | '/city-clerk/$id/overall-permits'
    | '/city-clerk/$id/permits'
    | '/city-clerk/roles-and-permissions/$roleId'
    | '/city-clerk/roles-and-permissions/new'
    | '/city-clerk/$id'
    | '/city-clerk/roles-and-permissions'
    | '/organization/$id'
    | '/city-clerk/$id/projects/$projectId'
    | '/city-clerk/$id/permit-template/$templateId'
    | '/city-clerk/$id/permit-template/new'
    | '/city-clerk/$id/compare'
    | '/city-clerk/$id/permit-template'
    | '/city-clerk/$id/projects'
    | '/city-clerk/$id/projects/$projectId/permits'
    | '/city-clerk/$id/projects/$projectId/permit-resubmission'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey'
    | '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/404'
    | '/resource-not-found'
    | '/auth/(auth)'
    | '/(app)/access-denied'
    | '/(app)/admin/implicit-ai-import'
    | '/(app)/city-clerk'
    | '/(app)/city-clerk/__city-clerk'
    | '/(app)/city-clerk/members'
    | '/(app)/city-clerk/projects'
    | '/(app)/city-clerk/settings'
    | '/(app)/superadmin/blocked-accounts'
    | '/(app)/superadmin/overview'
    | '/auth/(auth)/city-setup'
    | '/auth/(auth)/complete-profile'
    | '/auth/(auth)/continue-registration'
    | '/auth/(auth)/create-city-clerk'
    | '/auth/(auth)/create-organization'
    | '/auth/(auth)/invite'
    | '/auth/(auth)/suspended-city'
    | '/(app)/qc/'
    | '/(app)/city-clerk/$id/dashboard'
    | '/(app)/city-clerk/$id/notification'
    | '/(app)/city-clerk/$id/overall-permits'
    | '/(app)/city-clerk/$id/permits'
    | '/(app)/city-clerk/roles-and-permissions/$roleId'
    | '/(app)/city-clerk/roles-and-permissions/new'
    | '/(app)/city-clerk/$id/'
    | '/(app)/city-clerk/roles-and-permissions/'
    | '/(app)/organization/$id/'
    | '/(app)/city-clerk/$id/projects/$projectId'
    | '/(app)/city-clerk/$id/permit-template/$templateId'
    | '/(app)/city-clerk/$id/permit-template/new'
    | '/(app)/city-clerk/$id/compare/'
    | '/(app)/city-clerk/$id/permit-template/'
    | '/(app)/city-clerk/$id/projects/'
    | '/(app)/city-clerk/$id/projects/$projectId/permits'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-resubmission/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/'
    | '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  R404Route: typeof R404Route
  ResourceNotFoundRoute: typeof ResourceNotFoundRoute
  AuthauthRouteRoute: typeof AuthauthRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/resource-not-found': {
      id: '/resource-not-found'
      path: '/resource-not-found'
      fullPath: '/resource-not-found'
      preLoaderRoute: typeof ResourceNotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/city-clerk': {
      id: '/(app)/city-clerk'
      path: '/city-clerk'
      fullPath: '/city-clerk'
      preLoaderRoute: typeof appCityClerkRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/access-denied': {
      id: '/(app)/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof appAccessDeniedRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/auth/(auth)': {
      id: '/auth/(auth)'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/qc/': {
      id: '/(app)/qc/'
      path: '/qc'
      fullPath: '/qc'
      preLoaderRoute: typeof appQcIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/auth/(auth)/suspended-city': {
      id: '/auth/(auth)/suspended-city'
      path: '/suspended-city'
      fullPath: '/auth/suspended-city'
      preLoaderRoute: typeof AuthauthSuspendedCityRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/auth/(auth)/invite': {
      id: '/auth/(auth)/invite'
      path: '/invite'
      fullPath: '/auth/invite'
      preLoaderRoute: typeof AuthauthInviteRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/auth/(auth)/create-organization': {
      id: '/auth/(auth)/create-organization'
      path: '/create-organization'
      fullPath: '/auth/create-organization'
      preLoaderRoute: typeof AuthauthCreateOrganizationRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/auth/(auth)/create-city-clerk': {
      id: '/auth/(auth)/create-city-clerk'
      path: '/create-city-clerk'
      fullPath: '/auth/create-city-clerk'
      preLoaderRoute: typeof AuthauthCreateCityClerkRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/auth/(auth)/continue-registration': {
      id: '/auth/(auth)/continue-registration'
      path: '/continue-registration'
      fullPath: '/auth/continue-registration'
      preLoaderRoute: typeof AuthauthContinueRegistrationRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/auth/(auth)/complete-profile': {
      id: '/auth/(auth)/complete-profile'
      path: '/complete-profile'
      fullPath: '/auth/complete-profile'
      preLoaderRoute: typeof AuthauthCompleteProfileRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/auth/(auth)/city-setup': {
      id: '/auth/(auth)/city-setup'
      path: '/city-setup'
      fullPath: '/auth/city-setup'
      preLoaderRoute: typeof AuthauthCitySetupRouteImport
      parentRoute: typeof AuthauthRouteRoute
    }
    '/(app)/superadmin/overview': {
      id: '/(app)/superadmin/overview'
      path: '/superadmin/overview'
      fullPath: '/superadmin/overview'
      preLoaderRoute: typeof appSuperadminOverviewRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/superadmin/blocked-accounts': {
      id: '/(app)/superadmin/blocked-accounts'
      path: '/superadmin/blocked-accounts'
      fullPath: '/superadmin/blocked-accounts'
      preLoaderRoute: typeof appSuperadminBlockedAccountsRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/city-clerk/settings': {
      id: '/(app)/city-clerk/settings'
      path: '/settings'
      fullPath: '/city-clerk/settings'
      preLoaderRoute: typeof appCityClerkSettingsRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/projects': {
      id: '/(app)/city-clerk/projects'
      path: '/projects'
      fullPath: '/city-clerk/projects'
      preLoaderRoute: typeof appCityClerkProjectsRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/members': {
      id: '/(app)/city-clerk/members'
      path: '/members'
      fullPath: '/city-clerk/members'
      preLoaderRoute: typeof appCityClerkMembersRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/__city-clerk': {
      id: '/(app)/city-clerk/__city-clerk'
      path: '/city-clerk'
      fullPath: '/city-clerk'
      preLoaderRoute: typeof appCityClerk_cityClerkRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/admin/implicit-ai-import': {
      id: '/(app)/admin/implicit-ai-import'
      path: '/admin/implicit-ai-import'
      fullPath: '/admin/implicit-ai-import'
      preLoaderRoute: typeof appAdminImplicitAiImportRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/organization/$id/': {
      id: '/(app)/organization/$id/'
      path: '/organization/$id'
      fullPath: '/organization/$id'
      preLoaderRoute: typeof appOrganizationIdIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/city-clerk/roles-and-permissions/': {
      id: '/(app)/city-clerk/roles-and-permissions/'
      path: '/roles-and-permissions'
      fullPath: '/city-clerk/roles-and-permissions'
      preLoaderRoute: typeof appCityClerkRolesAndPermissionsIndexRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/': {
      id: '/(app)/city-clerk/$id/'
      path: '/$id'
      fullPath: '/city-clerk/$id'
      preLoaderRoute: typeof appCityClerkIdIndexRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/roles-and-permissions/new': {
      id: '/(app)/city-clerk/roles-and-permissions/new'
      path: '/roles-and-permissions/new'
      fullPath: '/city-clerk/roles-and-permissions/new'
      preLoaderRoute: typeof appCityClerkRolesAndPermissionsNewRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/roles-and-permissions/$roleId': {
      id: '/(app)/city-clerk/roles-and-permissions/$roleId'
      path: '/roles-and-permissions/$roleId'
      fullPath: '/city-clerk/roles-and-permissions/$roleId'
      preLoaderRoute: typeof appCityClerkRolesAndPermissionsRoleIdRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/permits': {
      id: '/(app)/city-clerk/$id/permits'
      path: '/$id/permits'
      fullPath: '/city-clerk/$id/permits'
      preLoaderRoute: typeof appCityClerkIdPermitsRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/overall-permits': {
      id: '/(app)/city-clerk/$id/overall-permits'
      path: '/$id/overall-permits'
      fullPath: '/city-clerk/$id/overall-permits'
      preLoaderRoute: typeof appCityClerkIdOverallPermitsRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/notification': {
      id: '/(app)/city-clerk/$id/notification'
      path: '/$id/notification'
      fullPath: '/city-clerk/$id/notification'
      preLoaderRoute: typeof appCityClerkIdNotificationRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/dashboard': {
      id: '/(app)/city-clerk/$id/dashboard'
      path: '/$id/dashboard'
      fullPath: '/city-clerk/$id/dashboard'
      preLoaderRoute: typeof appCityClerkIdDashboardRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/projects/': {
      id: '/(app)/city-clerk/$id/projects/'
      path: '/$id/projects'
      fullPath: '/city-clerk/$id/projects'
      preLoaderRoute: typeof appCityClerkIdProjectsIndexRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/permit-template/': {
      id: '/(app)/city-clerk/$id/permit-template/'
      path: '/$id/permit-template'
      fullPath: '/city-clerk/$id/permit-template'
      preLoaderRoute: typeof appCityClerkIdPermitTemplateIndexRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/compare/': {
      id: '/(app)/city-clerk/$id/compare/'
      path: '/$id/compare'
      fullPath: '/city-clerk/$id/compare'
      preLoaderRoute: typeof appCityClerkIdCompareIndexRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/permit-template/new': {
      id: '/(app)/city-clerk/$id/permit-template/new'
      path: '/$id/permit-template/new'
      fullPath: '/city-clerk/$id/permit-template/new'
      preLoaderRoute: typeof appCityClerkIdPermitTemplateNewRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/permit-template/$templateId': {
      id: '/(app)/city-clerk/$id/permit-template/$templateId'
      path: '/$id/permit-template/$templateId'
      fullPath: '/city-clerk/$id/permit-template/$templateId'
      preLoaderRoute: typeof appCityClerkIdPermitTemplateTemplateIdRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId': {
      id: '/(app)/city-clerk/$id/projects/$projectId'
      path: '/$id/projects/$projectId'
      fullPath: '/city-clerk/$id/projects/$projectId'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdRouteRouteImport
      parentRoute: typeof appCityClerkRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permits': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permits'
      path: '/permits'
      fullPath: '/city-clerk/$id/projects/$projectId/permits'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitsRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-resubmission/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-resubmission/'
      path: '/permit-resubmission'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-resubmission'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitResubmissionIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/'
      path: '/permit-checklist-setup/$permitId'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/new-playground'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
    '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/': {
      id: '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey/'
      path: '/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey'
      fullPath: '/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/admin-report/$templateKey'
      preLoaderRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRouteImport
      parentRoute: typeof appCityClerkIdProjectsProjectIdRouteRoute
    }
  }
}

interface appCityClerkIdProjectsProjectIdRouteRouteChildren {
  appCityClerkIdProjectsProjectIdPermitsRoute: typeof appCityClerkIdProjectsProjectIdPermitsRoute
  appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute
  appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute: typeof appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute
}

const appCityClerkIdProjectsProjectIdRouteRouteChildren: appCityClerkIdProjectsProjectIdRouteRouteChildren =
  {
    appCityClerkIdProjectsProjectIdPermitsRoute:
      appCityClerkIdProjectsProjectIdPermitsRoute,
    appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute:
      appCityClerkIdProjectsProjectIdPermitResubmissionIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdministrativeCheckIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAiProcessingProgressIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdDocumentComparisonIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdFirstSubmitalIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdNewPlaygroundIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdAdminReportTemplateKeyIndexRoute,
    appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute:
      appCityClerkIdProjectsProjectIdPermitChecklistSetupPermitIdPermitSubmitalIdHeavyReportTemplateKeyIndexRoute,
  }

const appCityClerkIdProjectsProjectIdRouteRouteWithChildren =
  appCityClerkIdProjectsProjectIdRouteRoute._addFileChildren(
    appCityClerkIdProjectsProjectIdRouteRouteChildren,
  )

interface appCityClerkRouteChildren {
  appCityClerk_cityClerkRoute: typeof appCityClerk_cityClerkRoute
  appCityClerkMembersRoute: typeof appCityClerkMembersRoute
  appCityClerkProjectsRoute: typeof appCityClerkProjectsRoute
  appCityClerkSettingsRoute: typeof appCityClerkSettingsRoute
  appCityClerkIdDashboardRoute: typeof appCityClerkIdDashboardRoute
  appCityClerkIdNotificationRoute: typeof appCityClerkIdNotificationRoute
  appCityClerkIdOverallPermitsRoute: typeof appCityClerkIdOverallPermitsRoute
  appCityClerkIdPermitsRoute: typeof appCityClerkIdPermitsRoute
  appCityClerkRolesAndPermissionsRoleIdRoute: typeof appCityClerkRolesAndPermissionsRoleIdRoute
  appCityClerkRolesAndPermissionsNewRoute: typeof appCityClerkRolesAndPermissionsNewRoute
  appCityClerkIdIndexRoute: typeof appCityClerkIdIndexRoute
  appCityClerkRolesAndPermissionsIndexRoute: typeof appCityClerkRolesAndPermissionsIndexRoute
  appCityClerkIdProjectsProjectIdRouteRoute: typeof appCityClerkIdProjectsProjectIdRouteRouteWithChildren
  appCityClerkIdPermitTemplateTemplateIdRoute: typeof appCityClerkIdPermitTemplateTemplateIdRoute
  appCityClerkIdPermitTemplateNewRoute: typeof appCityClerkIdPermitTemplateNewRoute
  appCityClerkIdCompareIndexRoute: typeof appCityClerkIdCompareIndexRoute
  appCityClerkIdPermitTemplateIndexRoute: typeof appCityClerkIdPermitTemplateIndexRoute
  appCityClerkIdProjectsIndexRoute: typeof appCityClerkIdProjectsIndexRoute
}

const appCityClerkRouteChildren: appCityClerkRouteChildren = {
  appCityClerk_cityClerkRoute: appCityClerk_cityClerkRoute,
  appCityClerkMembersRoute: appCityClerkMembersRoute,
  appCityClerkProjectsRoute: appCityClerkProjectsRoute,
  appCityClerkSettingsRoute: appCityClerkSettingsRoute,
  appCityClerkIdDashboardRoute: appCityClerkIdDashboardRoute,
  appCityClerkIdNotificationRoute: appCityClerkIdNotificationRoute,
  appCityClerkIdOverallPermitsRoute: appCityClerkIdOverallPermitsRoute,
  appCityClerkIdPermitsRoute: appCityClerkIdPermitsRoute,
  appCityClerkRolesAndPermissionsRoleIdRoute:
    appCityClerkRolesAndPermissionsRoleIdRoute,
  appCityClerkRolesAndPermissionsNewRoute:
    appCityClerkRolesAndPermissionsNewRoute,
  appCityClerkIdIndexRoute: appCityClerkIdIndexRoute,
  appCityClerkRolesAndPermissionsIndexRoute:
    appCityClerkRolesAndPermissionsIndexRoute,
  appCityClerkIdProjectsProjectIdRouteRoute:
    appCityClerkIdProjectsProjectIdRouteRouteWithChildren,
  appCityClerkIdPermitTemplateTemplateIdRoute:
    appCityClerkIdPermitTemplateTemplateIdRoute,
  appCityClerkIdPermitTemplateNewRoute: appCityClerkIdPermitTemplateNewRoute,
  appCityClerkIdCompareIndexRoute: appCityClerkIdCompareIndexRoute,
  appCityClerkIdPermitTemplateIndexRoute:
    appCityClerkIdPermitTemplateIndexRoute,
  appCityClerkIdProjectsIndexRoute: appCityClerkIdProjectsIndexRoute,
}

const appCityClerkRouteWithChildren = appCityClerkRoute._addFileChildren(
  appCityClerkRouteChildren,
)

interface appRouteRouteChildren {
  appAccessDeniedRoute: typeof appAccessDeniedRoute
  appAdminImplicitAiImportRoute: typeof appAdminImplicitAiImportRoute
  appCityClerkRoute: typeof appCityClerkRouteWithChildren
  appSuperadminBlockedAccountsRoute: typeof appSuperadminBlockedAccountsRoute
  appSuperadminOverviewRoute: typeof appSuperadminOverviewRoute
  appQcIndexRoute: typeof appQcIndexRoute
  appOrganizationIdIndexRoute: typeof appOrganizationIdIndexRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appAccessDeniedRoute: appAccessDeniedRoute,
  appAdminImplicitAiImportRoute: appAdminImplicitAiImportRoute,
  appCityClerkRoute: appCityClerkRouteWithChildren,
  appSuperadminBlockedAccountsRoute: appSuperadminBlockedAccountsRoute,
  appSuperadminOverviewRoute: appSuperadminOverviewRoute,
  appQcIndexRoute: appQcIndexRoute,
  appOrganizationIdIndexRoute: appOrganizationIdIndexRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface AuthauthRouteRouteChildren {
  AuthauthCitySetupRoute: typeof AuthauthCitySetupRoute
  AuthauthCompleteProfileRoute: typeof AuthauthCompleteProfileRoute
  AuthauthContinueRegistrationRoute: typeof AuthauthContinueRegistrationRoute
  AuthauthCreateCityClerkRoute: typeof AuthauthCreateCityClerkRoute
  AuthauthCreateOrganizationRoute: typeof AuthauthCreateOrganizationRoute
  AuthauthInviteRoute: typeof AuthauthInviteRoute
  AuthauthSuspendedCityRoute: typeof AuthauthSuspendedCityRoute
}

const AuthauthRouteRouteChildren: AuthauthRouteRouteChildren = {
  AuthauthCitySetupRoute: AuthauthCitySetupRoute,
  AuthauthCompleteProfileRoute: AuthauthCompleteProfileRoute,
  AuthauthContinueRegistrationRoute: AuthauthContinueRegistrationRoute,
  AuthauthCreateCityClerkRoute: AuthauthCreateCityClerkRoute,
  AuthauthCreateOrganizationRoute: AuthauthCreateOrganizationRoute,
  AuthauthInviteRoute: AuthauthInviteRoute,
  AuthauthSuspendedCityRoute: AuthauthSuspendedCityRoute,
}

const AuthauthRouteRouteWithChildren = AuthauthRouteRoute._addFileChildren(
  AuthauthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  R404Route: R404Route,
  ResourceNotFoundRoute: ResourceNotFoundRoute,
  AuthauthRouteRoute: AuthauthRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
